import { isDefined } from "@clipboard-health/util-ts";
import { isSameMinute } from "date-fns";

/**
 * Compares two dates using `isSameMinute`, but also
 * returns `true` if both arguments are `undefined`.
 *
 * @param date1
 * @param date2
 */
export function isSameOptionalMinute(date1?: Date, date2?: Date) {
  if (isDefined(date1) && isDefined(date2)) {
    return isSameMinute(date1, date2);
  }

  return date1 === date2;
}
